import { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface TimelineEvent {
  label: ReactNode
  date?: ReactNode
  done?: boolean
}

/** Časová osa událostí dokladu (Midday activity). */
export const Timeline = ({ events, className }: { events: TimelineEvent[]; className?: string }) => (
  <ol className={cn('relative space-y-3', className)}>
    {events.map((e, i) => (
      <li key={i} className="relative flex items-start justify-between gap-4 pl-5 text-sm">
        <span
          className={cn(
            'absolute left-0 top-1.5 size-2 rounded-full border',
            e.done === false ? 'border-muted-foreground bg-background' : 'border-foreground bg-foreground',
          )}
        />
        {i < events.length - 1 && <span className="absolute left-[3.5px] top-4 h-[calc(100%-4px)] w-px bg-border" />}
        <span className={cn(e.done === false && 'text-muted-foreground')}>{e.label}</span>
        {e.date && <span className="shrink-0 text-xs text-muted-foreground tabular">{e.date}</span>}
      </li>
    ))}
  </ol>
)
